module.exports = __webpack_public_path__ + "static/media/humming-bird.e7fd37a1.jpg";